const POSTS_URL = process.env.REACT_APP_POSTS_URL || "http://localhost:8001";
const DISCOVERY_URL = process.env.REACT_APP_DISCOVERY_URL || "http://localhost:8002";
const SOCIAL_URL = process.env.REACT_APP_SOCIAL_URL || "http://localhost:8003";
const LLM_URL = process.env.REACT_APP_LLM_URL || "http://localhost:8000";

async function request(base, path, options = {}) {
  const res = await fetch(`${base}${path}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  if (options.rawResponse) return res;
  if (res.status === 204) return null;
  const data = await res.json();
  if (!res.ok) throw { status: res.status, ...data };
  return data;
}

export const posts = {
  create: (data) =>
    request(POSTS_URL, "/posts", { method: "POST", body: JSON.stringify(data) }),
  get: (postId) =>
    request(POSTS_URL, `/posts/${postId}`),
  update: (postId, data) =>
    request(POSTS_URL, `/posts/${postId}`, { method: "PATCH", body: JSON.stringify(data) }),
  delete: (postId, authorId) =>
    request(POSTS_URL, `/posts/${postId}`, { method: "DELETE", body: JSON.stringify({ author_id: authorId }) }),
  respond: (postId, responderId) =>
    request(POSTS_URL, `/posts/${postId}/respond`, { method: "POST", body: JSON.stringify({ responder_id: responderId }) }),
  updateResponse: (postId, responseId, data) =>
    request(POSTS_URL, `/posts/${postId}/responses/${responseId}`, { method: "PATCH", body: JSON.stringify(data) }),
  completeResponse: (postId, responseId, authorId) =>
    request(POSTS_URL, `/posts/${postId}/responses/${responseId}/complete`, { method: "POST", body: JSON.stringify({ author_id: authorId }) }),
  getResponses: (postId, userId) =>
    request(POSTS_URL, `/posts/${postId}/responses?user_id=${userId}`),
  getMyPosts: (userId) =>
    request(POSTS_URL, `/users/${userId}/posts`),
  getMyResponses: (userId) =>
    request(POSTS_URL, `/users/${userId}/responses`),
};

export const discovery = {
  feed: (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.set(k, v);
    });
    return request(DISCOVERY_URL, `/feed?${qs}`);
  },
};

export const social = {
  submitRating: (responseId, data) =>
    request(SOCIAL_URL, `/responses/${responseId}/rate`, { method: "POST", body: JSON.stringify(data) }),
  getUserRatings: (userId, params = {}) => {
    const qs = new URLSearchParams(params);
    return request(SOCIAL_URL, `/users/${userId}/ratings?${qs}`);
  },
  getUserCp: (userId) =>
    request(SOCIAL_URL, `/users/${userId}/community-points`),
  getLeaderboard: () =>
    request(SOCIAL_URL, "/leaderboard"),
  getRecentDeeds: () =>
    request(SOCIAL_URL, "/leaderboard/recent-deeds"),
  getUserProfile: (userId) =>
    request(SOCIAL_URL, `/users/${userId}`),
};

export const llm = {
  streamChat: async (messages, onChunk) => {
    const res = await fetch(`${LLM_URL}/llm/complete/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages, max_tokens: 500 }),
    });
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop();
      for (const line of lines) {
        if (!line.startsWith("data: ")) continue;
        const payload = line.slice(6).trim();
        if (payload === "[DONE]") return;
        try {
          const parsed = JSON.parse(payload);
          const content = parsed.choices?.[0]?.delta?.content;
          if (content) onChunk(content);
        } catch {}
      }
    }
  },
};
